import { useEffect, useState } from "react";

interface NetworkInformation extends EventTarget {
  saveData?: boolean;
  effectiveType?: "slow-2g" | "2g" | "3g" | "4g";
}

const SLOW_EFFECTIVE_TYPES = new Set<NetworkInformation["effectiveType"]>(["slow-2g", "2g"]);

function readConnection(): NetworkInformation | undefined {
  return (navigator as Navigator & { connection?: NetworkInformation }).connection;
}

function isSlowConnection(c: NetworkInformation): boolean {
  return c.saveData === true || (c.effectiveType !== undefined && SLOW_EFFECTIVE_TYPES.has(c.effectiveType));
}

export function usePrefetchEnabled(): boolean {
  const [enabled, setEnabled] = useState<boolean>(() => {
    if (typeof navigator === "undefined") return true;
    const c = readConnection();
    return c ? !isSlowConnection(c) : true;
  });

  useEffect(() => {
    const c = readConnection();
    if (!c) return;
    const recompute = () => {
      const next = !isSlowConnection(c);
      setEnabled((prev) => (prev === next ? prev : next));
    };
    c.addEventListener("change", recompute);
    return () => c.removeEventListener("change", recompute);
  }, []);

  return enabled;
}
